(function () {
  const selectors = {
    slider: '.peek-carousel__slider',
  };

  function initPeekCarousel(sliderEl) {
    if (!sliderEl) return;

    if (typeof window.Swiper !== 'function') {
      if (!sliderEl._peekCarouselWaitingForSwiper) {
        sliderEl._peekCarouselWaitingForSwiper = true;
        const startTime = Date.now();
        const waitForSwiper = () => {
          if (typeof window.Swiper === 'function') {
            sliderEl._peekCarouselWaitingForSwiper = false;
            initPeekCarousel(sliderEl);
            return;
          }
          if (Date.now() - startTime > 4000) {
            sliderEl._peekCarouselWaitingForSwiper = false;
            return;
          }
          setTimeout(waitForSwiper, 50);
        };
        waitForSwiper();
      }
      return;
    }

    const allowTouchMove = sliderEl.dataset.allowTouch === 'true';
    const loop = sliderEl.dataset.loop === 'true';
    const autoplayEnabled = sliderEl.dataset.autoplay === 'true';
    const autoplayDelay = Number(sliderEl.dataset.autoplaySpeed || 5000);
    const spaceBetween = Number(sliderEl.dataset.spaceBetween || 12);
    const peekDesktop = sliderEl.dataset.peekDesktop || '12';
    const peekMobile = sliderEl.dataset.peekMobile || '16';
    const showDots = sliderEl.dataset.showDots === 'true';
    const showArrows = sliderEl.dataset.showArrows === 'true';
    const currentConfig = JSON.stringify({
      allowTouchMove,
      loop,
      autoplayEnabled,
      autoplayDelay,
      spaceBetween,
      peekDesktop,
      peekMobile,
      showDots,
      showArrows,
    });

    // Keep CSS variables in sync with data attributes
    sliderEl.style.setProperty('--peek-desktop', `${peekDesktop}%`);
    sliderEl.style.setProperty('--peek-mobile', `${peekMobile}%`);

    const swiperEl = sliderEl.querySelector('.swiper');
    const rootEl = sliderEl.closest('.peek-carousel') || sliderEl.parentElement;
    const paginationEl = rootEl?.querySelector('.peek-carousel__pagination') || sliderEl.querySelector('.peek-carousel__pagination');
    const paginationOuterEl = rootEl?.querySelector('.peek-carousel__pagination--outer') || paginationEl?.parentElement;
    const nextEl = sliderEl.querySelector('.peek-carousel__btn--next');
    const prevEl = sliderEl.querySelector('.peek-carousel__btn--prev');
    const baseSlideCount = sliderEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;

    if (!swiperEl) return;

    const previousConfig = sliderEl.dataset.peekConfig;
    if (sliderEl.dataset.initialized === 'true' && previousConfig === currentConfig) {
      if (!sliderEl._peekCarouselMutationObserver) {
        sliderEl._peekCarouselMutationObserver = new MutationObserver(() => initPeekCarousel(sliderEl));
        sliderEl._peekCarouselMutationObserver.observe(sliderEl, { attributes: true });
      }
      return;
    }

    sliderEl.dataset.peekConfig = currentConfig;

    if (sliderEl._peekCarouselBlockSelectHandler) {
      document.removeEventListener('shopify:block:select', sliderEl._peekCarouselBlockSelectHandler);
      sliderEl._peekCarouselBlockSelectHandler = null;
    }

    if (sliderEl._peekCarouselSwiper && typeof sliderEl._peekCarouselSwiper.destroy === 'function') {
      sliderEl._peekCarouselSwiper.destroy(true, true);
      sliderEl._peekCarouselSwiper = null;
    }

    const enableLoop = loop && baseSlideCount > 1;

    // eslint-disable-next-line no-undef
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween,
      speed: 550,
      loop: enableLoop,
      allowTouchMove,
      grabCursor: allowTouchMove,
      centeredSlides: false,
      watchOverflow: true,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: !allowTouchMove,
            pauseOnMouseEnter: true,
          }
        : false,
      pagination: showDots && paginationEl
        ? {
            el: paginationEl,
            clickable: allowTouchMove,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          }
        : undefined,
      navigation: showArrows && nextEl && prevEl
        ? {
            nextEl,
            prevEl,
          }
        : undefined,
    });

    sliderEl._peekCarouselSwiper = swiper;
    sliderEl.dataset.initialized = 'true';

    const updateArrows = () => {
      if (!showArrows || !nextEl || !prevEl) return;
      // In loop mode, always show arrows
      if (enableLoop) {
        nextEl.style.display = 'grid';
        prevEl.style.display = 'grid';
        return;
      }
      // In non-loop mode, hide arrows at start/end
      const isFirst = swiper.realIndex === 0;
      const isLast = swiper.realIndex === baseSlideCount - 1;
      nextEl.style.display = isLast ? 'none' : 'grid';
      prevEl.style.display = isFirst ? 'none' : 'grid';
    };

    if (paginationOuterEl) {
      paginationOuterEl.style.display = showDots ? '' : 'none';
    }

    if (nextEl) nextEl.style.display = '';
    if (prevEl) prevEl.style.display = '';
    if (showArrows) {
      updateArrows();
      swiper.on('slideChange', updateArrows);
    } else if (nextEl && prevEl) {
      nextEl.style.display = 'none';
      prevEl.style.display = 'none';
    }

    // Handle theme editor block selection
    sliderEl._peekCarouselBlockSelectHandler = (event) => {
      const blockId = event?.detail?.blockId;
      if (!blockId || !swiper) return;
      const slideEl = sliderEl.querySelector(`[data-block-id="${blockId}"]`);
      if (!slideEl) return;
      const index = Array.from(slideEl.parentNode.children).indexOf(slideEl);
      swiper.slideToLoop(index);
    };
    document.addEventListener('shopify:block:select', sliderEl._peekCarouselBlockSelectHandler);

    if (!sliderEl._peekCarouselMutationObserver) {
      sliderEl._peekCarouselMutationObserver = new MutationObserver(() => initPeekCarousel(sliderEl));
      sliderEl._peekCarouselMutationObserver.observe(sliderEl, { attributes: true });
    }
  }

  function init() {
    document.querySelectorAll(selectors.slider).forEach(initPeekCarousel);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

  if (document.readyState !== 'loading') init();
})();
